import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency'
})
export class customCurrency implements PipeTransform {

  transform(value: any, args?: any): any {
    let numArr = value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").split("");
    numArr[numArr.length-3] = ",";
    
    return  numArr.join('') + " €";
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/custom-currency.pipe.ts